import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import useRotaBase from '../../utils/useRotaBase';
import Cookies from 'js-cookie'

import { Container, Form, LinkTexto } from './styles';

import FormInput from '../../components/FormInput';
import Button from '../../components/Button';
import Copyright from '../../components/Copyright';
import Context, { IContext } from '../../context/Context';


import api from '../../services/api';

interface IFormData {
  usuario: string;
  sen: string;
}

export default function Login() {
  const navigate = useNavigate();
  const rotaBase = useRotaBase();
  const { setDadosUsuario, setIsLoadingOverlay, empresa }: IContext = useContext(Context);
  const [formData, setFormData] = useState<IFormData>({
    usuario: '',
    sen: '',
  });

  function redefenirSenha() {
    toast.info('Funcionalidade em desenvolvimento');
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    try {
      e.preventDefault();
      setIsLoadingOverlay(true);

      // Envio para API
      const response = await api.get('/login', {
        params: {
          usu: formData.usuario,
          sen: formData.sen
        }
      });

      if (response.status === 200) {
        setDadosUsuario(response.data);
        Cookies.set('dadosUsuario', JSON.stringify({
          email: response.data.email, nome: response.data.nome,
          cod: response.data.cod, imageURI: response.data.imageURI
        }));
        navigate(`${rotaBase}/inicio`);
        toast.success(`Seja bem-vindo ${response.data.nome}`);
        return;
      }

      toast.warning('Usuário ou senha incorretos');
    } catch (error: any) {
      if (error.response?.data.Erro) return toast.error(error.response.data.Erro);
      toast.error(error.message);
    } finally {
      setTimeout(() => setIsLoadingOverlay(false), 200);
    }
  }

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <img src={'https://tifire.com/assets/img/fogo2.png'} alt='TI.Fire Sistemas' />
        <h1>Bem-vindo ao SigepeWeb</h1>
        <h4>Acesse utilizando suas credenciais</h4>
        {empresa && <p className='empresa'>{empresa.raz} - {empresa.fil}</p>}
        <FormInput
          placeHolder='E-mail ou Usuário'
          required
          onChange={e => setFormData({ ...formData, usuario: e.target.value })}
          value={formData.usuario}
        />
        <FormInput
          placeHolder='Senha'
          type='password'
          ativarToggleMostrarSenha
          required
          onChange={e => setFormData({ ...formData, sen: e.target.value })}
          value={formData.sen}
          animated
          autoComplete='current-password'
        />
        <Button texto='Acessar' type='submit' larguraTotal />
        <LinkTexto type='button' onClick={redefenirSenha}>
          Esqueci minha senha
        </LinkTexto>
      </Form>
      <Copyright />
    </Container>
  )
}
